<div *ngIf="etat === 'loaded'" class="row space-above">
  <div class="col-sm-12">
    <div class="row">
      <div class="col-sm-12">
        <h2>Vous avez des questions ?</h2>
      </div>
    </div>

    <div class="panel-group panel-group-cnaf cnaf-margin-mobile" id="accordion-questions" role="tablist" aria-multiselectable="true">
      <div *ngFor="let question of questions; let questionIndex = index; let first = first;"
        class="panel panel-default">
        <div class="panel-heading" role="tab" [attr.id]="'heading-'+questionIndex">
          <h3 class="panel-title">
            <a role="button" data-toggle="collapse" data-parent="#accordion-questions"
              href="#collapse-{{questionIndex}}" [attr.aria-expanded]="first ? 'true' : 'false'"
              [attr.aria-controls]="'collapse-'+questionIndex" [ngClass]="!first ? 'collapsed' : ''">
              <span>{{question.titre}}</span>
            </a>
          </h3>
        </div>
        <div [attr.id]="'collapse-'+questionIndex" class="panel-collapse collapse" [ngClass]="first ? 'in' : ''"
          role="tabpanel" [attr.aria-labelledby]="'heading-'+questionIndex">
          <div class="panel-body">
            <div *ngFor="let descriptif of question.descriptifs;">
              <div *ngIf="!isBouton(descriptif)" [innerHTML]="descriptif.html"></div>
              <div *ngIf="isBouton(descriptif)">
                <div [outerHTML]="descriptif.html"></div>
                <a class="btn" [ngClass]="descriptif.etat === 'primaire' ? 'btn-primary-cnaf' : 'btn-secondary-cnaf'"
                  [href]="(descriptif.url && !descriptif.typeActionSpecifique ? descriptif.url : 'javascript:void(0);') | safeUrl" [innerHTML]="descriptif.titre"
                  (click)="getActionLienService(descriptif.typeActionSpecifique)"
                  [attr.target]="descriptif.ouvertureNouvelleFenetre ? '_blank' : '_self'"
                  [attr.title]="descriptif.ouvertureNouvelleFenetre ? descriptif.titre + ' (nouvelle fenêtre)': ''"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center">
      <a class="btn btn-primary-cnaf" href="/redirect/s/Redirect?page=foireAuxQuestions">Toutes les questions</a>
    </div>
  </div>
</div>